export enum InvitationType {
  ProjectRequest = 'project-request',
  ProjectCall = 'project-call',
  AdHocCallRequest = 'ad-hoc-call-request',
  AdHocCallTimeProposal = 'ad-hoc-call-time-proposal',
}